
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/industry/ecommerce/whatsapp",
      function () {
        return require("private-next-pages/industry/ecommerce/whatsapp.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/industry/ecommerce/whatsapp"])
      });
    }
  